export let UserPage = {
    path: 'userpage',
    name: 'user-page',
    component: () =>
        import(/* webpackChunkName: "user-page" */
        '@/views/back-stage/user-page/user-page.vue'),
    children: [
        {
            path: 'pageconfig',
            name: 'page-config',
            component: () =>
                import(/* webpackChunkName: "page-config" */
                '@/views/back-stage/user-page/page-config.vue'),
        },
        {
            path: 'web',
            name: 'web-client',
            component: () =>
                import(/* webpackChunkName: "web-client" */
                '@/views/back-stage/user-page/web-client.vue'),
        },
        {
            path: 'themeconfig',
            name: 'theme-config',
            component: () =>
                import(/* webpackChunkName: "theme-config" */ '@/views/back-stage/user-page/theme-config.vue'),
        },
        {
            path: 'naviconfig',
            name: 'navigator-config',
            component: () =>
                import(/* webpackChunkName: "navigator-config" */
                '@/views/back-stage/user-page/navigator-config.vue'),
        },
        {
            path: '*',
            redirect: 'pageconfig',
        },
    ],
};

export let PageMenegement = {
    path: 'pagemenegement',
    name: 'page-menegement',
    component: () =>
        import(/* webpackChunkName: "page-menegement" */ '@/views/back-stage/user-page/page-menegement.vue'),
    children: [
        {
            path: 'baseconfig',
            name: 'baseconfig',
            component: () =>
                import(/* webpackChunkName: "page-base-config" */ '@/views/back-stage/user-page/page-base-config.vue'),
        },
        {
            path: 'navigationconfig',
            name: 'navigationconfig',
            component: () =>
                import(/* webpackChunkName: "navigator-config" */ '@/views/back-stage/user-page/navigator-config.vue'),
        },
        {
            path: '*',
            redirect: 'baseconfig',
        },
    ],
};
